import { useContext } from 'react';
import { RomaneioFornContext } from '../context/RomaneioFornContext';
import { RomaneioFornContextData } from '../types/context';

export const useRomaneio = (): RomaneioFornContextData =>
  useContext(RomaneioFornContext);
